module.exports = __webpack_public_path__ + "img/forum-events.c6ffe0ef.svg";